export class TipoDeAcao {
  Id: number;
  Descricao: string;
  Ativo: boolean;
  AdvogadoId: number;
  AreaDescricao: string;
  AreaId: number;

  constructor() {
    this.Id = 0;
    this.Descricao = '';
    this.Ativo = true;
  }
}
